export enum FolderType {
    None,
    Standing,
    SubCommittee,
    Statutory,
    Parent,
    Meeting,
    SubCommitteeParent
}